/* eslint-disable import/no-unresolved */
/*
=========================================================
* Otis Kit PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-kit-pro-material-kit-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useRef } from 'react';

// SwiperJS
import SwiperCore, { Autoplay, Navigation } from 'swiper';

// SwiperJS react components
import { Swiper, SwiperSlide } from 'swiper/react';

// SwiperJS styles
import 'swiper/css';
import 'swiper/css/navigation';

// @mui material components
import Container from '@mui/material/Container';
import Icon from '@mui/material/Icon';

// Otis Kit PRO components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

// Otis Kit PRO examples
import ComplexReviewCard from 'examples/Cards/ReviewCards/ComplexReviewCard';

// Images
import review2 from 'assets/videos/DemoScout.mp4';
import review1 from 'assets/videos/demomovint.mp4';
import review3 from 'assets/videos/Demo Mi Taller.mp4';
import review4 from 'assets/videos/Demo.mp4';
import logoSpotify from 'assets/images/automotive/image (4).png';
import logoSlack from 'assets/images/automotive/image (5).png';
import logoMiTaller from 'assets/images/automotive/image (6).png';

function TestimonialsTwo() {
  // install SwiperJS modules
  SwiperCore.use([Autoplay, Navigation]);

  // Swiper navigation buttons styles
  const navigationStyles = {
    xs: { width: 'auto', height: '100%', alignItems: 'center', justifyContent: 'center' },
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    textAlign: 'center',
    opacity: 0.5,
    cursor: 'pointer',
    transition: 'opacity 0.15s ease',

    '&:hover, &:focus': {
      opacity: 1,
    },
  };

  // SwiperJS navigation buttons ref
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  return (
    <MKBox py={8} id="testimonials-two" position="relative">
      <MKBox textAlign="center" mb={6} data-aos="fade-up">
        <MKTypography variant="h3" textAlign="center" mt={-3} sx={{ color: '#1A73E8' }}>
          PRODUCTOS
        </MKTypography>
        <MKTypography textAlign="center" variant="body2" color="text" mt={1}>
          Conoce algunas de las soluciones tecnológicas que hemos desarrollado y puedes adaptar a
          las necesidades de tu organización.
        </MKTypography>
      </MKBox>

      <Swiper
        onInit={({ params, navigation }) => {
          const { navigation: nav } = params;

          nav.prevEl = navigationPrevRef.current;
          nav.nextEl = navigationNextRef.current;
          navigation.init();
          navigation.update();
        }}
        autoplay={{ delay: 62000 }}
        speed={800}
        spaceBetween={0}
        slidesPerView={1}
        loop
      >
        <SwiperSlide>
          <Container sx={{ px: { xs: 7, md: 0 } }} data-aos="fade-up">
            <ComplexReviewCard
              video={review1}
              title="Sistema de cámara con visión a la vía y cabina"
              review="Para la grabación continua de video, permitiendo el monitoreo del vehículo para la prevención y disminución de accidentes automovilísticos."
              author={{
                logo: logoSpotify,
                name: 'Moviint',
                // role: "Marketing Manager - Spotify",
              }}
            />
          </Container>
        </SwiperSlide>
        <SwiperSlide>
          <Container sx={{ px: { xs: 7, md: 0 } }} data-aos="fade-up">
            <ComplexReviewCard
              video={review2}
              title="Software de monitoreo de activos digitales"
              review="Facilita el inventario de equipos, administración de licencias y optimización del uso digital."
              author={{
                logo: logoSlack,
                name: 'Scout',
              }}
            />
          </Container>
        </SwiperSlide>
        <SwiperSlide>
          <Container sx={{ px: { xs: 7, md: 0 } }} data-aos="fade-up">
            <ComplexReviewCard
              video={review3}
              title="Gestión y administración de talleres automotrices"
              review="Optimiza la trazabilidad de los procesos y la toma de decisiones en los talleres mecánicos."
              author={{
                logo: logoMiTaller,
                name: 'Mi Taller',
              }}
            />
          </Container>
        </SwiperSlide>
        {/* <SwiperSlide>
          <Container>
            <ComplexReviewCard
              video={review4}
              title="Awesome services! Fast and secure."
              review="Wealth creation is an evolutionarily recent positive-sum game. Status is an old zero-sum game. Those attacking wealth creation are often just seeking ."
              author={{
                logo: logoSlack,
                name: "Mathew Glock",
                role: "CFO - Slack",
              }}
            />
          </Container>
        </SwiperSlide> */}
        <MKTypography
          alignItems="center"
          variant="h2"
          color="dark"
          sx={{
            ...navigationStyles,
            left: 0,
          }}
          ref={navigationPrevRef}
        >
          <Icon>chevron_left</Icon>
        </MKTypography>
        <MKTypography
          alignItems="center"
          variant="h2"
          color="dark"
          sx={{
            ...navigationStyles,
            right: 0,
          }}
          ref={navigationNextRef}
        >
          <Icon>chevron_right</Icon>
        </MKTypography>
      </Swiper>
    </MKBox>
  );
}

export default TestimonialsTwo;
